import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useTranslate from '@core/hooks/useTranslate';
import useDebounce from '@root/core/hooks/useDebounce';
import StockServices from '@root/modules/Sellers/Stock/services/stock';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Card, DatePicker, Menu, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import DropdownButton from '../../Inquiry/components/DropdownButton';
import SearchBox from '../../Inquiry/components/Search';
import BreadcrumbList from '../components/Breadcrumb';
import WarehouseInfo from '../components/WarehouseInfo';

interface DataType {
  key: React.Key;
  no: number;
  productName: string;
  sku: number;
  quantity: number;
  updated_at: Date;
  detailAddress: string;
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const StockWarehouse = () => {
  const [t] = useTranslate();
  const [info, setInfo] = useState({} as any);
  const [listData, setListData] = useState([]);
  const history = useHistory();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [listExcel, setListExcel] = useState([] as any);
  const [save, setSave] = useState([] as any);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(2);
  const [totalItem, setTotaItem] = useState();
  const [loading, setLoading] = useState(false);
  const [labelType, setLabelType] = useState({
    key: '2',
    label: t('seller:button:select')
  } as any);
  const [proName, setProName] = useState('');
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [sort, setSort] = useState(true);
  const { stockId }: any = useParams();
  const [dateValue, setDateValue] = useState<[string, string]>();
  const fromDt: string = (dateValue && dateValue[0]) || '';
  const toDt: string = (dateValue && dateValue[1]) || '';
  const [breadcrumb, setBreadcrumb] = useState<
    { tittle: string; url: string }[]
  >([
    {
      tittle: '재고 관리',
      url: '/admin/seller/stock'
    },
    {
      tittle: '물류센터 조회',
      url: '/admin/seller/stock'
    }
  ]);

  const columns: ColumnsType<DataType> = [
    {
      title: 'No',
      dataIndex: 'id'
    },
    {
      title: t('table:seller:product-name'),
      dataIndex: 'productName'
    },

    {
      title: 'SKU',
      dataIndex: 'sku'
    },
    {
      title: t('table:seller:quantity'),
      dataIndex: 'quantity'
    },
    {
      title: '위치',
      dataIndex: 'detailAddress'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {t('table:seller:update')}
          {!!sort ? (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
              }}
            />
          ) : (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(true)}
            />
          )}
        </div>
      ),
      dataIndex: 'updated_at'
      // key: "updated_at",
    }
  ];

  const getProductName = (e: any) => {
    setProName(e.key);
    setLabelType({ key: e.key, label: e.domEvent.target.innerText });
  };
  const onChangeState = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDate = (value: [string, string]) => {
    setDateValue(value);
  };
  const listLabel = [
    {
      id: 1,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getProductName}
          items={[
            {
              label: t('table:seller:product-name'),
              key: 'productName'
            },
            {
              type: 'divider'
            },
            {
              label: 'SKU',
              key: 'sku'
            }
          ]}
        />
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeyss: React.Key[], selectedRows: DataType[]) => {
      setListExcel(selectedRows);
      setSelectedRowKeys(selectedRowKeyss);
      if (
        save.length > 0 &&
        save.some((item: any) => item.page == currentPage)
      ) {
        let a = save.findIndex((item: any) => item.page == currentPage);
        save[a] = { page: currentPage, select: selectedRowKeyss };
      } else {
        setSave((item: any) => [
          ...item,
          ...[{ page: currentPage, select: selectedRowKeyss }]
        ]);
      }
    },
    getCheckboxProps: (record: DataType) => ({
      // disabled: record.productName === "Disabled User", // Column configuration not to be checked
      name: record.productName
    })
  };

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY/MM/DD';
  const idExport = listExcel.map((item: any) => ({
    key: item.key
  }));

  const handelExportExcel = async (
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string,
    numberDetail: number
  ) => {
    if (listExcel.length > 0) {
      let selected = save.reduce(
        (s: number[], x: any) => [...s, ...x.select],
        []
      );
      const responseById = await StockServices.exportExcelByIdOfListStock(
        selected,
        stockId
      );
      const outputFilename = `Stock_${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([responseById]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await StockServices.exportExcelAllOfListStock({
        fieldSearch,
        productName,
        sort,
        fromDt,
        toDt,
        numberDetail
      });
      const outputFilename = `Stock_${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  const getDetail = async () => {
    try {
      const detailInfo = await StockServices.getDetailInfo(stockId);
      let mainProduct = detailInfo?.data.majorStorageProducts.reduce(
        (item: string, value: any) =>
          !!value.majorStorageProductName
            ? (item += value.majorStorageProductName + ', ')
            : item,
        ''
      );
      setInfo({ ...detailInfo.data, mainProduct: mainProduct });
      setBreadcrumb((item) => [
        ...item,
        ...[{ tittle: detailInfo?.data?.name, url: '' }]
      ]);
    } catch (e) {
      setInfo(null);
    }
  };

  const getPagination = async (
    page: number,
    fieldSearch: string,
    productName: string,
    sort: boolean,
    id: number,
    fromDt: string,
    toDt: string
  ) => {
    setLoading(true);
    try {
      const temp = await StockServices.getPagingStock({
        productName,
        page,
        fieldSearch,
        sort,
        id,
        fromDt,
        toDt
      });
      let list = temp.data.map((item: any, index: number) => {
        return {
          ...item,
          updated_at: formatDateTime(item.updated_at),
          // updated_at: moment(item.updated_at)
          //   .utc(true ?? 9)
          //   .format('YYYY-MM-DD hh:mm:ss A'),
          no: index + 1,
          quantity: item?.inventory?.remainQuantity || 0,
          key: item.id,
          detailAddress: item?.inventory?.location ?? ''
        };
      });
      setListData(list);
      setTotalPages(temp.meta.totalPages);
      setCurrentPage(temp.meta.currentPage);
      setTotaItem(temp.meta.totalItems);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  useEffect(() => {
    getPagination(1, proName, valueSearch, sort, stockId, fromDt, toDt);
  }, [debounc, proName, sort, fromDt, toDt]);

  return (
    <>
      <BreadcrumbList listBreadcrumb={breadcrumb} />
      <div className="admin-container">
        <WarehouseInfo info={info} />
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          ></div>
          <div className="control">
            <RangePicker
              onChange={(date: any, dateString: [string, string]) => {
                getDate(dateString);
              }}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              format={dateFormat}
            />
            {listLabel.map((item) => {
              return (
                <DropdownButton
                  key={item.id}
                  label={labelType.label}
                  menu={item.listMenu}
                />
              );
            })}
            <SearchBox
              type
              onChange={(e: any) =>
                onChangeState('Value Search', e.target.value)
              }
            />
          </div>
          <div className="table">
            <div>
              <div
                style={{
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 16
                }}
              >
                <div className="table__head">
                  <span style={{ marginLeft: 8 }}>
                    총 재고 &nbsp; {totalItem}
                  </span>
                  <span className="table__head --right">
                    선택 재고 &nbsp;
                    {listExcel.length}
                  </span>
                </div>

                <div>
                  <Button
                    className="downExcel"
                    onClick={() => {
                      handelExportExcel(
                        valueSearch,
                        proName,
                        sort,
                        fromDt,
                        toDt,
                        stockId
                      );
                    }}
                  >
                    {t('common:download')}
                  </Button>
                </div>
              </div>
              <Table
                loading={loading}
                columns={columns}
                dataSource={listData}
                rowSelection={rowSelection}
                pagination={{
                  total: totalPages * 10,
                  onChange: (page, limit) => {
                    getPagination(
                      page,
                      valueSearch,
                      proName,
                      sort,
                      stockId,
                      fromDt,
                      toDt
                    );
                  }
                }}
                onRow={(item) => {
                  return {
                    onClick: () => {
                      history.push(`/admin/seller/stock-detail/${item.key}`);
                    }
                  };
                }} // onRow={() => ()}
              />
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default StockWarehouse;
